import {useRouteError, isRouteErrorResponse} from "react-router";
import PageTitle from "../../global/components/PageTitle";


const Error = () => {
    const error = useRouteError();
    return <PageTitle title={isRouteErrorResponse(error) ? "Ungültige Seite" : "Ein Fehler ist aufgetreten"} />
}

export default Error;